import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class CityColumn extends Column {
    title = 'company.offices.cityColumn';
    property = 'city';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
